import { createScorableTab } from './scorableTabFactory';
import { registerTab } from './tabRegistry';

// Default flow — "Passed" tab. Registry key matches the flow-statuses API's
// exact status string ("Passed") — see FailedTab.jsx's comment.
const PassedTab = createScorableTab('Passed', 'No candidates have passed yet.');

registerTab({
  stateMachineKey: 'default',
  state: 'Passed',
  component: PassedTab,
});

export default PassedTab;
